import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { inferScenarioContentMode } from "../../utils/contentMode";

const prodURL = "https://club-lab.ru";
const mediaBaseUrl =
  window.location.hostname === "localhost" ? "http://localhost:3004" : prodURL;

export function getServerMediaUrl(relativePath) {
  if (!relativePath) return null;

  const normalized = String(relativePath).replace(/^\/+/, "");
  return `${mediaBaseUrl}/${normalized}`;
}

export function useSceneScreenshot(nodeId, propsData) {
  const game = useSelector((state) => state.user?.game);
  const [imageKey, setImageKey] = useState(0);

  const sceneData =
    game?.nodes?.find((node) => String(node.id) === String(nodeId))?.data ??
    propsData;
  const contentMode = inferScenarioContentMode(sceneData);
  const screenpath = sceneData?.screenpath;
  const imagepath = sceneData?.imagepath;
  const hasScreenshot = contentMode === "video" && Boolean(screenpath);
  const hasImagePreview = contentMode === "image" && Boolean(imagepath);
  const imageSrc = hasScreenshot
    ? `${getServerMediaUrl(screenpath)}?v=${imageKey}`
    : null;
  const imagePreviewSrc = hasImagePreview
    ? `${getServerMediaUrl(imagepath)}?v=${imageKey}`
    : null;

  useEffect(() => {
    if (screenpath || imagepath) {
      setImageKey((prev) => prev + 1);
    }
  }, [screenpath, imagepath]);

  const refreshScreenshot = useCallback(() => {
    setImageKey((prev) => prev + 1);
  }, []);

  return {
    sceneData,
    contentMode,
    hasScreenshot,
    hasImagePreview,
    imageSrc,
    imagePreviewSrc,
    imageKey,
    refreshScreenshot,
  };
}
